<script setup lang="ts">
import { useAdvisors, type AdvisorsFilters } from '@/src/composables/useAdvisors';
import { useGlobalProperties } from '@/src/composables/useGlobalProperties';
import SeAdvisorCard from '@/src/modules/advisor/components/advisor-card.vue';
import SeSpinner from '@/src/ui-kit/spinner/Spinner.vue';
import { theme } from '@/theme';
import { onMounted, onUnmounted, ref } from 'vue';

const { advisor } = theme.home;
const hasTriedSecondFetch = ref(false);
const { getGlobalProperties } = useGlobalProperties();
const { advisors, fetchAdvisors, perPage } = useAdvisors();

const { $auth } = getGlobalProperties();

const defaultFilters: AdvisorsFilters = {
  status: '',
  isAuthenticated: $auth.check(),
  limit: perPage.value,
};

const loadAdvisors = async (status: string) => {
  try {
    await fetchAdvisors({ ...defaultFilters, status });

    if (advisors.value.length === 0 && status === 'online' && !hasTriedSecondFetch.value) {
      await fetchAdvisors(defaultFilters);
    }
    hasTriedSecondFetch.value = true;
  } catch (error) {
    console.error('Error loading advisors:', error);
    hasTriedSecondFetch.value = true;
  }
};

onMounted(async () => {
  await loadAdvisors('online');
});

onUnmounted(() => {
  hasTriedSecondFetch.value = false;
});
</script>

<script lang="ts">
export default {
  name: 'SeAdvisorTopAdvisorsList',
};
</script>

<template>
  <section class="py-32 md:py-48 lg:py-88">
    <div class="advisors-list" :class="advisor?.cardName">
      <slot name="header" />

      <div v-if="!hasTriedSecondFetch" class="flex justify-center py-88">
        <se-spinner />
      </div>
      <div class="advisors-list-container">
        <article v-for="advisor of advisors" :key="advisor.id + advisor.url" class="w-full">
          <se-advisor-card :advisor="advisor" />
        </article>
      </div>

      <slot name="footer" />
    </div>
  </section>
</template>
